import {IconHeartHandshake, IconRocket, IconSchool} from "@tabler/icons-react"
import React from "react"
import CardIcon from "~/common/components/atoms/card-icon/card-icon"
import "./why-doxpro.scss"

export function WhyDoxpro() {
  return (
    <div className="why">
      <div className="container">
        <div className="why__heading heading" id="whydoxpro">
          <div className="heading__title">Why Doxpro?</div>
          <div className="heading__subtitle">
            <em>doxpro</em> delivers in several key areas
          </div>
        </div>
        <div className="why__cards flex-wrap">
          <div className="col">
            <CardIcon title="Boost your team productivity" icon={<IconRocket size={32} />}>
              <p>
                Based on careful examination of your context our team will provide you with the best tooling based on MS
                capabilities and our vast experience.
              </p>
              <p>
                We will be plugging-in convenient shortcuts into your existing process making it way faster and more
                effective.
              </p>
            </CardIcon>
          </div>
          <div className="col">
            <CardIcon title="Increase customer loyalty and retention" icon={<IconHeartHandshake size={32} />}>
              <p className="col-thin">
                Doxpro documents are based on a professionally designed, brand aware integrated templates.
              </p>
              <p className="col-thin">
                A sense of high quality documents will be consistent and will help retain clients.
              </p>
            </CardIcon>
          </div>
          <div className="col">
            <CardIcon title="Promote best practices" icon={<IconSchool size={32} />}>
              <p className="col-thin">Onboarding within a team will become easier.</p>
              <p>
                New members will be using your business best practices in the form of the live cloud templates right
                away.
              </p>
            </CardIcon>
          </div>
        </div>
      </div>
    </div>
  )
}
